import clsx from "clsx";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import { NavLink } from "react-router-dom";
import { Ribbon } from "../../commons/Ribbon";
import { useObservable } from "src/framework/store/storeUtil";
import { FC, ReactNode } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { MenuUserInfo } from "../MenuUserInfo";
import { UserClassificacaoInfo } from "../UserClassificaoInfo";
import { CacheType, contaUsuario$ } from "src/store/global.store";
import { ContaUsuario } from "src/store/global.store.types";
import theme from "src/theme/light";
import "./style.css";
import { openMenu$, pageTitle$ } from "src/framework/store/AppStore";
import { userInfo$ } from "src/framework/store/LoginStore";

export interface IApplicationBar {
  classes: any;
  logo?: ReactNode;
  disableMenu?: boolean;
  children: ReactNode;
}

const ApplicationBar: FC<IApplicationBar> = ( { classes, logo = "", disableMenu = false, children}) => {

  const ambiente = `${process.env.REACT_APP_ENV_LABEL}`
  const isProd = String(process.env.REACT_APP_IS_PROD).toUpperCase() === "TRUE";
  const pageTitle = useObservable(pageTitle$);
  const userInfo = useObservable(userInfo$)
  const contaUsuario = useObservable<CacheType<ContaUsuario | null>>(contaUsuario$);

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <AppBar position="fixed" className={classes.appBar} color="inherit">
      <Toolbar>
        {!isProd ? <Ribbon label={ambiente} side="left" /> : ""}
        {!disableMenu && (<IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={() => openMenu$.next(!openMenu$.getValue())}
          edge="start"
          className={clsx(classes.menuButton)}
          size="large">
          <MenuIcon />
        </IconButton>)}
        <NavLink to={"/"}>
          {logo}
        </NavLink>
        <Typography variant="h6" className="title" style={{ fontWeight: "bold", textAlign: "left", paddingLeft: "48px" }}>{pageTitle}</Typography>
        {children ? <div style={{ display: "flex", flexDirection: "row", flexGrow: 1}}>{children}</div> : ""}
        <Box display="flex" justifyContent='flex-end'>
          { !isMobile && <UserClassificacaoInfo userInfo={userInfo} contaUsuario={contaUsuario?.data} />}
          <Box width={"auto"}>
            <MenuUserInfo user={userInfo} />
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export { ApplicationBar };
